import { first, forEach, get } from '@libs/shared';
import { IFile } from '~/interfaces';
import { MAX_IMAGE_VIEW_SIZE } from '~/constants';
import { post } from './request';

/**
 * 是否为PDF
 *
 * @param ext
 */
export const isPdfExt = (ext: string) => {
    return /^pdf$/i.test(ext);
};

/**
 * 文件扩展名是否合法
 *
 * @param file
 * @param exts
 */
export const validExt = (file: File, exts: string[]) => {
    if (!file || !file.type) {
        return false;
    } else if (!exts.includes(file.type)) {
        return false;
    }
    return true;
};

/**
 * 判断是否是可预览的图片类型(大于20M图片不能预览)
 *
 * @param file
 */
export const isPreviewImage = (file: IFile) => {
    return file.size <= MAX_IMAGE_VIEW_SIZE;
};

interface IUploadInfo {
    tokenUrl: string;
    tokenData?: Record<string, any>;
    uploadData?: Record<string, any>;
    fileBlob: Blob;
    fileName?: string;
}

/**
 * 上传文件
 *
 * @param uploadInfo
 */
export const uploadBlob = (uploadInfo: IUploadInfo) => {
    const { tokenUrl, tokenData, uploadData, fileBlob, fileName } = uploadInfo;
    return post(tokenUrl, {
        ...tokenData,
        fileCount: 1
    }).then((res) => {
        const url = get(res, 'data.url');
        const tokenList = get(res, 'data.tokenList');
        const token = get(res, 'data.token');
        const formData = new FormData();
        formData.append('token', first(tokenList) || token);
        forEach(uploadData, (v, k) => {
            formData.append(k, v);
        });
        formData.append('file', fileBlob, fileName);
        return post(url, formData);
    });
};
